<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-6">
        <span class="cat__core__title">Create User</span>
      </div>
      <div class="col-lg-6 text-right">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany Logo" class="form-logo">
      </div>
    </div>
  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-lg-12">
        <form [formGroup]="trialUserForm" class="well">
          <div class="modal-body">
            
            <!-- Personal Details Section -->
            <div class="row userdetail">
              <div class="col-md-6" style="padding: 0 45px 0 20px;"> 
                <h4 class="title">Personal Details</h4>
                
                <!-- User Type Selection -->
                <div class="row">
                  <div class="col-md-12 d-flex">
                    <label class="form-control-label">User Type <span>*</span></label>
                    <div class="form-group gender d-flex" style="margin: 0 20px;">
                      <div class="tooltip1">
                        <label class="disabled-radio">Employee
                          <input type="radio" name="TypeOfUser" value="Employee" formControlName="TypeOfUser" disabled> 
                        </label>
                        <span class="tooltiptext">User type is locked to Board Member for trial users</span>
                      </div>
                      <div class="tooltip1">
                        <label class="disabled-radio">Executive Management
                          <input type="radio" name="TypeOfUser" value="ExecutiveManagement" formControlName="TypeOfUser" disabled> 
                        </label>
                        <span class="tooltiptext">User type is locked to Board Member for trial users</span>
                      </div>
                      <div class="tooltip1">
                        <label class="disabled-radio">KMP
                          <input type="radio" name="TypeOfUser" value="KMP" formControlName="TypeOfUser" disabled> 
                        </label>
                        <span class="tooltiptext">User type is locked to Board Member for trial users</span>
                      </div>
                      <div class="tooltip1">
                        <label class="disabled-radio selected">Board Member
                          <input type="radio" name="TypeOfUser" value="BoardMember" formControlName="TypeOfUser" checked disabled> 
                        </label>
                        <span class="tooltiptext">User type is set to Board Member for trial users</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <small class="form-text text-muted">User type is locked to "Board Member" for trial users.</small>
                  </div>
                </div>

                <!-- Director Type Selection (for Board Members) -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Director Type <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <select class="form-control" formControlName="DirectorType" (change)="onSelectedDirectorType($event)">
                        <option value="">Select Director Type</option>
                        <option *ngFor="let type of directorTypesList" [value]="type.value">{{ type.label }}</option>
                      </select>
                      <div *ngIf="trialUserForm.get('DirectorType')?.hasError('required') && trialUserForm.get('DirectorType')?.touched"
                        class="form-control-error-custom">
                        Director Type is required
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Name Fields -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="tooltip1">
                      <label class="form-control-label" for="l0">First Name <span>*</span></label>
                      <span class="tooltiptext">Please add first name</span>
                    </div>
                  </div>
                  <div class="col-md-4" style="padding-left:10px;">
                    <div class="form-group">
                      <select class="form-control" formControlName="TitleName">
                        <option value="">Select Title</option>
                        <option *ngFor="let title of titleList" [value]="title.value">{{ title.label }}</option>
                      </select>
                    </div>
                  </div> 
                  <div class="col-md-8">
                    <div class="form-group">
                      <input placeholder="First Name" type="text" class="form-control" formControlName="FirstName">
                      <div *ngIf="trialUserForm.get('FirstName')?.hasError('required') && trialUserForm.get('FirstName')?.touched"
                        class="form-control-error-custom">
                        First Name is required
                      </div>
                      <div *ngIf="trialUserForm.get('FirstName')?.hasError('pattern')" class="form-control-error-custom">
                        Please enter valid First Name
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="tooltip1">
                      <label class="form-control-label" for="l0">Last Name <span>*</span></label>
                      <span class="tooltiptext">Please add last name</span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Last Name" type="text" class="form-control" formControlName="LastName">
                      <div *ngIf="trialUserForm.get('LastName')?.hasError('required') && trialUserForm.get('LastName')?.touched"
                        class="form-control-error-custom">
                        Last Name is required
                      </div>
                      <div *ngIf="trialUserForm.get('LastName')?.hasError('pattern')" class="form-control-error-custom">
                        Please enter valid Last Name
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Designation -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Designation <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <select class="form-control" formControlName="DesignationSelection">
                        <option value="">Select Designation</option>
                        <option *ngFor="let designation of boardDesignationlist" [value]="designation.value">{{ designation.label }}</option>
                      </select>
                      <div *ngIf="trialUserForm.get('DesignationSelection')?.hasError('required') && trialUserForm.get('DesignationSelection')?.touched"
                        class="form-control-error-custom">
                        Please select Designation.
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Area of Expertise -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Area of Expertise </label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea placeholder="Area of Expertise" class="form-control" rows="2" formControlName="AreaofExpertise"></textarea>
                      <div *ngIf="trialUserForm.get('AreaofExpertise')?.invalid && trialUserForm.get('AreaofExpertise')?.touched" class="form-control-error-custom">
                        <div *ngIf="trialUserForm.get('AreaofExpertise')?.hasError('required')">Area of Expertise is required</div>
                        <div *ngIf="trialUserForm.get('AreaofExpertise')?.hasError('minlength')">Area of Expertise must be at least 5 characters</div>
                        <div *ngIf="trialUserForm.get('AreaofExpertise')?.hasError('pattern')">Area of Expertise can only contain alphabets and spaces</div>
                        <div *ngIf="trialUserForm.get('AreaofExpertise')?.hasError('maxlength')">Area of Expertise should be maximum 500 characters</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Experience -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Experience (Years)</label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Experience in Years" type="number" class="form-control" formControlName="Experience">
                    </div>
                  </div>
                </div>

                <!-- Gender -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Gender </label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group gender d-flex">
                      <label style="margin-right: 15px;">
                        <input type="radio" name="Gender" value="Male" formControlName="Gender">
                        Male
                      </label>
                      <label style="margin-right: 15px;">
                        <input type="radio" name="Gender" value="Female" formControlName="Gender">
                        Female
                      </label>
                      <label>
                        <input type="radio" name="Gender" value="Other" formControlName="Gender">
                        Other
                      </label>
                    </div>
                    <div *ngIf="trialUserForm.get('Gender')?.hasError('required') && trialUserForm.get('Gender')?.touched" class="form-control-error-custom">
                      Gender is required
                    </div>
                  </div>
                </div>

                <!-- Date of Birth -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Date of Birth </label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input type="date" class="form-control" formControlName="DOB">
                    </div>
                  </div>
                </div>

                <!-- Remuneration -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Remuneration (Annual) </label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Annual Remuneration" type="number" class="form-control" formControlName="Remuneration">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Contact Details Section -->
              <div class="col-md-6" style="padding: 0 20px 0 45px;">
                <h4 class="title">Contact Details</h4>
                
                <!-- Email -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Primary Email <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Primary Email" type="email" class="form-control" formControlName="EmailId">
                      <div *ngIf="trialUserForm.get('EmailId')?.hasError('required') && trialUserForm.get('EmailId')?.touched"
                        class="form-control-error-custom">
                        Primary Email is required
                      </div>
                      <div *ngIf="trialUserForm.get('EmailId')?.hasError('email')" class="form-control-error-custom">
                        Please enter valid Email
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mobile Numbers -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Primary Mobile <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Primary Mobile Number" type="tel" class="form-control" formControlName="MobileNumber">
                      <div *ngIf="trialUserForm.get('MobileNumber')?.hasError('required') && trialUserForm.get('MobileNumber')?.touched"
                        class="form-control-error-custom">
                        Primary Mobile is required
                      </div>
                      <div *ngIf="trialUserForm.get('MobileNumber')?.hasError('pattern')" class="form-control-error-custom">
                        Please enter valid 10-digit Mobile Number
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Additional Information -->
                <h4 class="title mt-4">Additional Information</h4>
                <!-- Role Information -->
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Role <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="Role" type="text" class="form-control" formControlName="RoleName" readonly>
                      <small class="form-text text-muted">Role is set to "Trial" by default for trial users.</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">PAN <span>*</span></label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="PAN" type="text" class="form-control" formControlName="PAN">
                      <div *ngIf="trialUserForm.get('PAN')?.invalid && trialUserForm.get('PAN')?.touched" class="form-control-error-custom">
                        <div *ngIf="trialUserForm.get('PAN')?.hasError('required')">PAN is required</div>
                        <div *ngIf="trialUserForm.get('PAN')?.hasError('pattern')">Please enter valid PAN (e.g., ABCDE1234F)</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">DIN Number</label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input placeholder="DIN Number" type="text" class="form-control" formControlName="DIN" readonly>
                      <small class="form-text text-muted">DIN is auto-configured for trial users.</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label" for="l0">Category </label>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <select class="form-control" formControlName="Category">
                        <option value="">Select Category</option>
                        <option *ngFor="let category of categoryList" [value]="category.value">{{ category.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Notification Preferences -->
                <h4 class="title mt-4">Notification Preferences </h4>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="container">
                        <input type="checkbox" formControlName="SMSNotification">
                        SMS Notifications
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="container">
                        <input type="checkbox" formControlName="EmailNotification" [checked]="true">
                        Email Notifications
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="container">
                        <input type="checkbox" formControlName="BellNotification">
                        Bell Notifications
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    </div>
                    </div>
                    <h4 class="title mt-4">Login Access </h4>
                    <div class="row">
                      <div class="col-md-12">
                    <div class="form-group">
                      <label class="container">
                        <input type="checkbox" formControlName="IPADNotification" [checked]="true">
                        iPad Access
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="container">
                        <input type="checkbox" formControlName="BrowserNotification" [checked]="true">
                        Browser Access
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()">
                  <i class="fa fa-user-plus mr-2" aria-hidden="true"></i>Create Trial User
                </button>
                <div class="mt-2">
                  <small class="text-muted">Form Status: {{ trialUserForm.valid ? 'Valid ✓' : 'Invalid ✗' }}</small>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<app-alert></app-alert>